import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { MessageService } from 'primeng/api';


@Injectable({ providedIn: 'root' })
export class NotificationService {

    constructor(public messageService: MessageService) {
    }

    showSuccess(message: string) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    }

    showError(message: string) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    }

    showWarning(message: string) {
        this.messageService.add({ severity: 'warning', summary: 'Warning', detail: message });
    }

    showInfo(message: string) {
        this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
    }

    showErrorFromResponse(res: any, defaultResponse: string) {
        let message;
        if (res && res.errors && res.errors.length) message = (<any>res.errors[0]).reason || res.errors[0].message;
        else {
            const err: Error = <any>res;
            console.error(err);
            message = err.message;
        }
        if (!message) message = _.get(res, 'error.message');
        this.showError(message || defaultResponse);
    }
}
